import React, {useContext} from "react";
import ReactDom from "react-dom";
import { keyContext } from '../KeyContext'


const Modal = ({ open, children }) => {
      const {leftMargin} = useContext(keyContext)
      const clientHeight =document.getElementById('tes')?  document.getElementById('tes').clientHeight : '1380px'
      const windowHeight = window.innerHeight
    // console.log(clientHeight, 'client height')
     if (!open) return null;
     return (
    <>
      <div style={{position:'fixed',display:'flex',justifyContent:'center',top: '0px',left:leftMargin,width:'100%',height:'100vh', backgroundColor:'rgba(0,0,0,0.5)',zIndex:100,overflowY:'auto'}}>
        {children}
      </div>
    </>
  );
};

export default Modal;